module.exports = __webpack_public_path__ + "static/media/chart-benefit-icon.66851ecb.svg";